





















































import { computed, defineComponent } from '@vue/composition-api';
import { ChevronLeftIcon, ArrowLeftIcon } from 'tdesign-icons-vue';
export default defineComponent({
  components: {
    ChevronLeftIcon,
    ArrowLeftIcon,
  },
  props: {
    crumbs: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: 0,
    },
    isSyncFolder: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    forceShowBackArrow: {
      type: Boolean,
      default: false,
    },
    maxItemWidth: {
      type: String,
      default: '190',
    },
  },
  setup(props, context) {
    const mobileCurrIndex = computed(() => props.crumbs.length - 1);
    const changeCrumb = (item: ListBreadcrumb, index: number, backCrumb: boolean) => {
      context.emit('change', {
        index,
        name: item.name,
        item,
        backCrumb,
      });
    };
    const backCrumb = () => {
      if (mobileCurrIndex.value - 1 < props.startIndex) {
        changeCrumb(props.crumbs[0] as ListBreadcrumb, 0, true);
        return;
      }
      changeCrumb(props.crumbs[mobileCurrIndex.value - 1] as ListBreadcrumb, mobileCurrIndex.value - 1, true);
    };
    const onMouseUp = (item: ListBreadcrumb, index: number) => {
      context.emit('onMouseUp', {
        item,
        index,
      });
    };
    return {
      mobileCurrIndex,
      changeCrumb,
      onMouseUp,
      backCrumb,
    };
  },
});
